import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Card, CardContent, TextField, Button, Typography, Alert } from '@mui/material';
import { forgotPasswordApi, resetPasswordApi } from '../../api/auth';

export default function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await forgotPasswordApi({ email });
      setMsg('Reset token sent. ' + (res.data.reset_token ? `Token: ${res.data.reset_token}` : 'Check your email.'));
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.email?.[0] || 'Request failed.');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await resetPasswordApi({ token, new_password: newPassword, confirm_new_password: confirm });
      setStep(3);
    } catch (err) {
      const d = err.response?.data;
      setError(d?.token?.[0] || d?.new_password?.[0] || d?.non_field_errors?.[0] || 'Reset failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 2 }}>
      <Card sx={{ maxWidth: 420, width: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" sx={{ mb: 1 }}>Reset Password</Typography>

          {step === 1 && (
            <Box component="form" onSubmit={handleRequest}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Enter your email to receive a reset token.
              </Typography>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              <TextField fullWidth label="Email Address" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)} required sx={{ mb: 2 }} />
              <Button type="submit" fullWidth variant="contained" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Token'}
              </Button>
            </Box>
          )}

          {step === 2 && (
            <Box component="form" onSubmit={handleReset}>
              {msg && <Alert severity="info" sx={{ mb: 2 }}>{msg}</Alert>}
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              <TextField fullWidth label="Reset Token" value={token}
                onChange={(e) => setToken(e.target.value)} required sx={{ mb: 2 }} />
              <TextField fullWidth label="New Password" type="password" value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)} required sx={{ mb: 2 }} />
              <TextField fullWidth label="Confirm Password" type="password" value={confirm}
                onChange={(e) => setConfirm(e.target.value)} required sx={{ mb: 2 }} />
              <Button type="submit" fullWidth variant="contained" disabled={loading}>
                {loading ? 'Resetting...' : 'Reset Password'}
              </Button>
            </Box>
          )}

          {step === 3 && (
            <Box sx={{ textAlign: 'center' }}>
              <Alert severity="success" sx={{ mb: 2 }}>Password reset successfully!</Alert>
              <Button variant="contained" component={RouterLink} to="/login">Back to Login</Button>
            </Box>
          )}

          {step < 3 && (
            <Box sx={{ textAlign: 'center', mt: 2 }}>
              <RouterLink to="/login" style={{ fontSize: 14, color: '#1565c0' }}>Back to Login</RouterLink>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
